import { FiX } from 'react-icons/fi';
import { useDropzone } from 'react-dropzone';
import { useCallback } from 'react';

interface FileUploadProps {
  label: string;
  name: string;
  formik: any;
  removeDocument: (type: any) => void;
  maxSizeLabel?: string; // e.g. "1MB" or "2MB"
}

// //payload is
// label = '3 Months Payslip';
// name = 'ParentRecords_PaySlip';
// formik = { formik };
// removeDocument = { removeDocument };

const BankStatementUpload: React.FC<FileUploadProps> = ({
  label,
  name,
  formik,
  removeDocument,

  maxSizeLabel = '5MB',
}) => {
  const onDropBankStatements = useCallback(
    (acceptedFiles: File[]) => {
      const currentFile = formik.values?.ParentRecords_BankStatement || null;

      // Process the new file
      const filteredFile = acceptedFiles.find(
        (file) => file.size <= 5 * 1024 * 1024
      );

      if (!filteredFile) {
        formik.setFieldError(
          'ParentRecords_BankStatement',
          'File size is too large. Maximum size is 5MB.'
        );
        formik.setFieldTouched('ParentRecords_BankStatement', true, false);
      } else if (filteredFile && currentFile !== null) {
        formik.setFieldError(
          'ParentRecords_BankStatement',
          'You can only upload one bank statement.'
        );
        formik.setFieldTouched('ParentRecords_BankStatement', true, false);
        return;
      } else {
        formik.setFieldValue('ParentRecords_BankStatement', filteredFile);
        formik.setFieldError('ParentRecords_BankStatement', '');
      }
    },
    [formik]
  );

  const { getRootProps, getInputProps } = useDropzone({
    onDrop: onDropBankStatements,
    accept: { 'image/jpeg': [], 'application/pdf': [] },
  });

  return (
    <div className="col-span-1">
      <p>{label}</p>
      <div className="flex items-center justify-center flex-col border rounded-md p-3">
        <div
          {...getRootProps()}
          className="flex items-center justify-center flex-col cursor-pointer"
        >
          <input {...getInputProps()} />
          <img src="/Assets/upload.svg" className="w-12" alt="upload" />
          <p>
            <span className="text-blue-500 font-medium">Click to upload</span>{' '}
            or drag and drop
          </p>
          <p className="text-xs">.jpeg or .pdf (max. {maxSizeLabel})</p>

          {formik.errors[name] && (
            <div className="text-red-500 text-xs text-center">
              {formik.errors[name] as string}
            </div>
          )}
        </div>

        {formik.values[name] && (
          <ul className="mt-2">
            <li className="flex justify-between items-center">
              <span>{formik.values[name]?.name}</span>
              <button
                type="button"
                onClick={() => removeDocument(name)}
                className="text-red-500"
              >
                <FiX />
              </button>
            </li>
          </ul>
        )}
      </div>
    </div>
  );
};

export default BankStatementUpload;
